module.exports = __webpack_public_path__ + "static/img/学习强国.42a9549.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/学习强国.png
// module id = VeTo
// module chunks = 1